// src/games/darkforest/items.js

export const items = {
  // Weapons
  rusty_dagger: {
    id: 'rusty_dagger',
    name: 'Rusty Dagger',
    description: 'An old, rusty dagger. It might not be very effective, but it\'s better than nothing.',
    type: 'WEAPON',
    rarity: 'COMMON',
    value: 2,
    weight: 1,
    stats: {
      damage: '1d4',
      damageType: 'piercing',
      properties: 'light, finesse'
    }
  },
  hunter_bow: {
    id: 'hunter_bow',
    name: 'Hunter\'s Bow',
    description: 'A well-crafted wooden bow. Perfect for hunting or defending yourself from a distance.',
    type: 'WEAPON',
    rarity: 'UNCOMMON',
    value: 25,
    weight: 2,
    stats: {
      damage: '1d6',
      damageType: 'piercing',
      range: '80/320',
      properties: 'ammunition, two-handed'
    }
  },
  whisperleaf_staff: {
    id: 'whisperleaf_staff',
    name: 'Whisperleaf Staff',
    description: 'A staff carved from the rare whisperleaf tree. The wood seems to resonate with magical energy.',
    type: 'WEAPON',
    rarity: 'RARE',
    value: 100,
    weight: 4,
    stats: {
      damage: '1d6',
      damageType: 'bludgeoning',
      properties: 'versatile (1d8)',
      special: '+1 to spell attack rolls'
    }
  },
  
  // Armor
  padded_vest: {
    id: 'padded_vest',
    name: 'Padded Vest',
    description: 'A simple padded vest that offers minimal protection.',
    type: 'ARMOR',
    rarity: 'COMMON',
    value: 5,
    weight: 4,
    stats: {
      armorClass: 11,
      type: 'light',
      strength: null,
      stealth: 'normal'
    }
  },
  leather_armor: {
    id: 'leather_armor',
    name: 'Leather Armor',
    description: 'A sturdy set of leather armor, well-worn but still protective.',
    type: 'ARMOR',
    rarity: 'COMMON',
    value: 10,
    weight: 10,
    stats: {
      armorClass: 11,
      type: 'light',
      strength: null,
      stealth: 'normal'
    }
  },
  forest_cloak: {
    id: 'forest_cloak',
    name: 'Forest Cloak',
    description: 'A dark green cloak that helps you blend in with the forest foliage.',
    type: 'ARMOR',
    rarity: 'UNCOMMON',
    value: 50,
    weight: 3,
    stats: {
      armorClass: '+1',
      type: 'wondrous',
      special: 'Advantage on Stealth checks in forest environments'
    }
  },
  
  // Potions
  minor_healing_potion: {
    id: 'minor_healing_potion',
    name: 'Minor Healing Potion',
    description: 'A small vial of red liquid that heals minor wounds when consumed.',
    type: 'POTION',
    rarity: 'COMMON',
    value: 15,
    weight: 0.5,
    stats: {
      effect: 'Heal 2d4+2 hit points',
      uses: 1
    }
  },
  antitoxin: {
    id: 'antitoxin',
    name: 'Antitoxin',
    description: 'A vial of antitoxin, useful for counteracting poisons.',
    type: 'POTION',
    rarity: 'COMMON',
    value: 50,
    weight: 0.5,
    stats: {
      effect: 'Advantage on saving throws against poison for 1 hour',
      uses: 1
    }
  },
  elixir_of_clarity: {
    id: 'elixir_of_clarity',
    name: 'Elixir of Clarity',
    description: 'This sparkly blue potion clears the mind and sharpens the senses.',
    type: 'POTION',
    rarity: 'UNCOMMON',
    value: 75,
    weight: 0.5,
    stats: {
      effect: '+2 to Perception and Investigation checks for 1 hour',
      uses: 1
    }
  },
  
  // Scrolls
  scroll_light: {
    id: 'scroll_light',
    name: 'Scroll of Light',
    description: 'A spell scroll containing the Light cantrip.',
    type: 'SCROLL',
    rarity: 'COMMON',
    value: 10,
    weight: 0.1,
    stats: {
      spell: 'Light',
      level: 'Cantrip',
      school: 'Evocation',
      uses: 1
    }
  },
  scroll_identify: {
    id: 'scroll_identify',
    name: 'Scroll of Identify',
    description: 'A spell scroll containing the Identify spell.',
    type: 'SCROLL',
    rarity: 'UNCOMMON',
    value: 100,
    weight: 0.1,
    stats: {
      spell: 'Identify',
      level: '1st level',
      school: 'Divination',
      uses: 1
    }
  },
  
  // Miscellaneous
  torch: {
    id: 'torch',
    name: 'Torch',
    description: 'A simple wooden torch soaked in pitch. Burns for about 1 hour.',
    type: 'MISCELLANEOUS',
    rarity: 'COMMON',
    value: 1,
    weight: 1,
    stats: {
      light: '20 feet bright, 20 feet dim',
      duration: '1 hour',
      uses: 1
    }
  },
  rope: {
    id: 'rope',
    name: 'Hempen Rope (50 feet)',
    description: 'A sturdy hempen rope, useful for climbing and securing things.',
    type: 'MISCELLANEOUS',
    rarity: 'COMMON',
    value: 1,
    weight: 10,
    stats: {
      strength: 'Holds up to 400 pounds',
      hp: 2
    }
  },
  mysterious_crystal: {
    id: 'mysterious_crystal',
    name: 'Mysterious Crystal',
    description: 'A strange, faintly glowing crystal. It seems to pulse with an unknown energy.',
    type: 'MISCELLANEOUS',
    rarity: 'RARE',
    value: 250,
    weight: 0.5,
    stats: {
      effect: 'Unknown'
    }
  },
  forest_map: {
    id: 'forest_map',
    name: 'Forest Map',
    description: 'A hand-drawn map of the Dark Forest, showing major paths and landmarks.',
    type: 'MISCELLANEOUS',
    rarity: 'UNCOMMON',
    value: 25,
    weight: 0.1,
    stats: {
      effect: 'Advantage on Survival checks to navigate the Dark Forest'
    }
  }
};